package com.hyperether.goodjob.repository.remote.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FinishJobRequest(
    @SerialName("id") val id: String,
    @SerialName("status") val status: String
)